export default "__VITE_ASSET__CWm00QkS__"